import { useMemo } from 'react';

import { FileLoader } from '../loaders/file-loader';

export function useFileLoader(): FileLoader {
  return useMemo(() => new FileLoader(), []);
}
